import { render, staticRenderFns } from "./EmphasisMarkDialog.vue?vue&type=template&id=44d00960&scoped=true"
import script from "./EmphasisMarkDialog.vue?vue&type=script&lang=ts"
export * from "./EmphasisMarkDialog.vue?vue&type=script&lang=ts"
import style0 from "./EmphasisMarkDialog.vue?vue&type=style&index=0&id=44d00960&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44d00960",
  null
  
)

export default component.exports